import clsx from "clsx";

const PhotoParentheses = ({ isAnimate = false, isActive = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100.611"
      viewBox="0 0 100 100.611"
      className={clsx("photo_parentheses", {
        animate: isAnimate,
        active: isActive,
      })}
    >
      <path
        d="M1004.238,0H954.679V14.1h33.136V71.875h16.423Z"
        transform="translate(-904.238)"
        fill="#3e29ff"
      />
      <path
        d="M49.559,0H0V14.1H33.136V71.875H49.559Z"
        transform="translate(49.56 100.611) rotate(180)"
        fill="#060606"
      />
    </svg>
  );
};

export default PhotoParentheses;
